import Tooltip from "@atlaskit/tooltip";
import { DynamicTable } from "@atlassiansox/microscopekit";
import React from "react";
import { formatTimeStamp, timeFromNow } from "../../utils/time";
var tableHead = {
    cells: [
        {
            key: "name",
            content: "Name",
            isSortable: true,
        },
        {
            key: "last_modified",
            content: "Last Modified",
            shouldTruncate: true,
            isSortable: true,
        },
    ],
};
var createRow = function (asset) { return [
    {
        key: asset.name,
        content: React.createElement("a", { href: asset.url }, asset.name),
    },
    {
        key: asset.lastModified,
        content: (React.createElement(Tooltip, { content: formatTimeStamp(asset.lastModified).toString() },
            React.createElement("span", null, timeFromNow(asset.lastModified)))),
    },
]; };
var makeRows = function (assets) {
    var tableRows = [];
    assets.forEach(function (asset) {
        tableRows.push({
            cells: createRow(asset),
        });
    });
    return tableRows;
};
var DataCatalogTable = function (_a) {
    var title = _a.title, rowsPerPage = _a.rowsPerPage, assets = _a.assets;
    return (React.createElement(DynamicTable, { head: tableHead, rows: assets ? makeRows(assets) : [], rowsPerPage: rowsPerPage || undefined, defaultSortKey: "last_modified", emptyView: React.createElement("h3", null, "No data found"), caption: title }));
};
export default DataCatalogTable;
